/**
 * Subtasks API Integration
 */

import axiosClient from '../axiosClient';
import { Subtask, CreateSubtaskDto, UpdateSubtaskDto } from '../types/SubtaskTypes';

export const subtasksApi = {
  /**
   * Get all subtasks for a task
   */
  getTaskSubtasks: async (taskId: string): Promise<Subtask[]> => {
    try {
      const response = await axiosClient.get(`/tasks/${taskId}/subtasks`);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching subtasks:', error);
      throw error;
    }
  },

  /**
   * Create a subtask on a task
   */
  createSubtask: async (taskId: string, data: CreateSubtaskDto): Promise<Subtask> => {
    try {
      const response = await axiosClient.post(`/tasks/${taskId}/subtasks`, data);
      console.log('✅ Subtask created on task:', taskId);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating subtask:', error);
      throw error;
    }
  },

  /**
   * Update a subtask (title, status, assignee, position)
   */
  updateSubtask: async (
    taskId: string,
    subtaskId: string,
    data: UpdateSubtaskDto,
  ): Promise<Subtask> => {
    try {
      const response = await axiosClient.patch(
        `/tasks/${taskId}/subtasks/${subtaskId}`,
        data,
      );
      console.log('✅ Subtask updated:', subtaskId);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating subtask:', error);
      throw error;
    }
  },

  /**
   * Delete a subtask
   */
  deleteSubtask: async (taskId: string, subtaskId: string): Promise<void> => {
    try {
      await axiosClient.delete(`/tasks/${taskId}/subtasks/${subtaskId}`);
      console.log('✅ Subtask deleted:', subtaskId);
    } catch (error) {
      console.error('❌ Error deleting subtask:', error);
      throw error;
    }
  },
};

export default subtasksApi;
